import type { FC } from 'react';
import { useEffect } from 'react';
import useTimer from '@customHooks/useTimer';
import { Modal } from '@ui';
import { observer } from 'mobx-react';
import './index.scss';

interface SuccessModalWithTimerProps {
  text?: string;
  title?: string;
  timerDuration?: number;
  closeModal: () => void;
}

const CompleteModalWithTimer: FC<SuccessModalWithTimerProps> = observer(
  ({ text = '', title = 'Cпасибо !', timerDuration = 3, closeModal }) => {
    const { timer } = useTimer(timerDuration);

    useEffect(() => {
      if (timer === 0) {
        closeModal();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timer]);

    return (
      <Modal framed crossOutside open onClose={closeModal}>
        <div className='complete-modal'>
          <div className='complete-modal__title'>{title}</div>
          {text && <div className='complete-modal__text'>{text}</div>}
        </div>
      </Modal>
    );
  }
);

export default CompleteModalWithTimer;
